import React, { useState } from "react";
import Navbar from "../components/navbar";
import BrochureForm from "../components/EnquiryForm";
import CTAButtons from "../components/sticky-button";
import Footer from "../components/Footer";
import PageHeader from "../about/PageHeader";
import {
  MdEdit,
  MdEmail,
  MdExpandMore,
  MdFormatListBulleted,
  MdGroups,
  MdPerson,
  MdPhone,
  MdSecurity,
  MdSend,
} from "react-icons/md";
import "./GrievanceForm.css";

const GrievanceForm = () => {
  const [showForm, setShowForm] = useState(false);
  const [form, setForm] = useState({
    name: "",
    email: "",
    mobile: "",
    stakeholder: "",
    category: "",
    comment: "",
  });
  const [submitting, setSubmitting] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");

  const handleChange = (e) => {
    const { id, value } = e.target;
    setForm((prev) => ({ ...prev, [id]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      const res = await fetch("/api/grievances", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(form),
      });

      if (!res.ok) {
        throw new Error("Failed to submit grievance");
      }

      setSuccessMessage("Your grievance has been submitted. Please check your email.");
      setForm({
        name: "",
        email: "",
        mobile: "",
        stakeholder: "Student",
        category: "Academics",
        comment: "",
      });
      setTimeout(() => setSuccessMessage(""), 5000);
    } catch (err) {
      console.error(err);
      setSuccessMessage("Something went wrong. Please try again later.");
      setTimeout(() => setSuccessMessage(""), 5000);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <>
      <Navbar setShowForm={setShowForm} />
      {showForm && <BrochureForm setShowForm={setShowForm} />}
      <CTAButtons />

      <PageHeader
        title="Student Grievance Redressal"
        crumbs={[
          { label: "Home", href: "/" },
          { label: "Student Grievance Redressal" },
        ]}
      />

      <main className="contact-container">
        <div className="gf-dot-pattern gf-dot-pattern-left" aria-hidden="true" />
        <div className="gf-dot-pattern gf-dot-pattern-right" aria-hidden="true" />
        <div className="contact-left">
          <div className="gf-form-wrapper">
            <form className="gf-form" onSubmit={handleSubmit}>
              <div className="gf-grid-two-cols">
                <div className="gf-form-group">
                  <label className="gf-label" htmlFor="name">
                    Your Name <span className="gf-required">*</span>
                  </label>
                  <div className="gf-control-wrap">
                    <MdPerson className="gf-field-icon" aria-hidden="true" />
                    <input
                      id="name"
                      type="text"
                      placeholder="Enter your full name"
                      className="gf-input"
                      required
                      value={form.name}
                      onChange={handleChange}
                    />
                  </div>
                </div>
                <div className="gf-form-group">
                  <label className="gf-label" htmlFor="email">
                    Your Email <span className="gf-required">*</span>
                  </label>
                  <div className="gf-control-wrap">
                    <MdEmail className="gf-field-icon" aria-hidden="true" />
                    <input
                      id="email"
                      type="email"
                      placeholder="Enter your email address"
                      className="gf-input"
                      required
                      value={form.email}
                      onChange={handleChange}
                    />
                  </div>
                </div>
              </div>

              <div className="gf-form-group">
                <label className="gf-label" htmlFor="mobile">
                  Your Mobile Number <span className="gf-required">*</span>
                </label>
                <div className="gf-control-wrap">
                  <MdPhone className="gf-field-icon" aria-hidden="true" />
                  <input
                    id="mobile"
                    type="tel"
                    placeholder="Enter your mobile number"
                    className="gf-input"
                    required
                    value={form.mobile}
                    onChange={handleChange}
                  />
                </div>
              </div>

              <div className="gf-grid-two-cols">
                <div className="gf-form-group">
                  <label className="gf-label" htmlFor="stakeholder">
                    Select Stakeholders <span className="gf-required">*</span>
                  </label>
                  <div className="gf-control-wrap gf-select-wrapper">
                    <MdGroups className="gf-field-icon" aria-hidden="true" />
                    {/* Stakeholder Dropdown */}
                    <select
                      id="stakeholder"
                      className="gf-select"
                      required
                      value={form.stakeholder}
                      onChange={handleChange}
                    >
                      <option value="" disabled>Select Stakeholders</option>
                      <option>Student</option>
                      <option>Parent/Guardian</option>
                      <option>Employee</option>
                      <option>Recruiter</option>
                      <option>Other</option>
                    </select>
                    <MdExpandMore className="gf-select-icon" aria-hidden="true" />
                  </div>
                </div>
                <div className="gf-form-group">
                  <label className="gf-label" htmlFor="category">
                    Select Categories <span className="gf-required">*</span>
                  </label>
                  <div className="gf-control-wrap gf-select-wrapper">
                    <MdFormatListBulleted
                      className="gf-field-icon"
                      aria-hidden="true"
                    />
                  <select
  id="category"
  className="gf-select"
  required
  value={form.category}
  onChange={handleChange}
>
  <option value="" disabled>Select Categories</option>
  <option>Anti-Ragging/Harasement</option>
  <option>Infrastucture</option>
  <option>Academics</option>
  <option>Examination</option>
  <option>Admission</option>
  <option>Others</option>
</select>
                    <MdExpandMore className="gf-select-icon" aria-hidden="true" />
                  </div>
                </div>
              </div>

              <div className="gf-form-group">
                <label className="gf-label" htmlFor="comment">
                  Comment / Grievance Details <span className="gf-required">*</span>
                </label>
                <div className="gf-control-wrap gf-textarea-wrap">
                  <MdEdit className="gf-field-icon" aria-hidden="true" />
                  <textarea
                    id="comment"
                    placeholder="Describe your grievance in detail..."
                    className="gf-textarea"
                    rows="4"
                    required
                    maxLength="1000"
                    value={form.comment}
                    onChange={handleChange}
                  ></textarea>
                  <span className="gf-char-count">{form.comment.length}/1000</span>
                </div>
              </div>

              <div className="gf-form-submit-wrapper">
                <button
                  type="submit"
                  className="gf-submit-button"
                  disabled={submitting}
                >
                  <MdSend className="gf-submit-icon" aria-hidden="true" />
                  {submitting ? "Submitting..." : "Submit Grievance"}
                </button>
              </div>
            </form>
            {successMessage && (
              <div className="gf-success-message">
                {successMessage}
              </div>
            )}
            <div className="gf-secure-note">
              <MdSecurity className="gf-secure-icon" aria-hidden="true" />
              Your information is secure and will only be used to address your grievance.
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
};

export default GrievanceForm;
